import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Option } from '@vendasta/forms';
import { Observable } from 'rxjs';
import { SalesTeamMultiSelectStoreService } from './sales-team-multi-select-store.service';
import { map, take } from 'rxjs/operators';
import { UntypedFormControl } from '@angular/forms';
import { SubscriptionList } from '@vendasta/rx-utils';
import { SalesTeamOption } from '../filter-options/sales-team-option.model';

@Component({
  selector: 'sales-ui-sales-team-multi-select',
  templateUrl: './sales-team-multi-select.component.html',
  styleUrls: ['./sales-team-multi-select.component.scss'],
  standalone: false,
})
export class SalesTeamMultiSelectComponent implements OnInit, OnDestroy {
  selectableSalesTeams$: Observable<Option[]>;
  readonly formControl: UntypedFormControl = new UntypedFormControl([], []);
  private readonly subscriptions = SubscriptionList.new();

  constructor(
    public dialogRef: MatDialogRef<SalesTeamMultiSelectComponent>,
    private readonly store: SalesTeamMultiSelectStoreService,
  ) {}

  ngOnInit(): void {
    this.selectableSalesTeams$ = this.store.selectableSalesTeams$.pipe(
      map((st: SalesTeamOption[]): Option[] => st.map((s) => ({ name: s.teamName, value: s.toOptionValue() }))),
    );
    this.subscriptions.add(
      this.store.selectedSalesTeams$.pipe(
        take(1),
        map((st: SalesTeamOption[]): string[] => st.map((s) => s.toOptionValue())),
      ),
      (st) => this.formControl.setValue(st),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.destroy();
  }

  cancel(): void {
    this.dialogRef.close();
  }

  save(): void {
    this.store.setSelectedSalesTeams(this.formControl.value);
    this.dialogRef.close();
  }
}
